<template>
	<div style="height: 100%;">
		<wc-monitor-d></wc-monitor-d>
	</div>
</template>

<script>
	export default{
		name:'MonitorDetail',
		data(){
			return {
				
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/monitor/MonitorDetail.vue